// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"3cdbbd4a","252":"c35765ad","693":"8b787b54","711":"ca453817"}[chunkId] + ".chunk.js";
};